import React, { useState, useMemo } from 'react';
import { FiSearch, FiCheck } from 'react-icons/fi';

const SUGGESTED_DESTINATIONS = ['Europa', 'Estados Unidos', 'Argentina', 'Brasil', 'México', 'Costa Rica', 'Venezuela'];

const MobileDestinationHybrid = ({
  options,
  value,
  onChange,
  validationError,
  onConfirm,
}) => {
  const [search, setSearch] = useState('');

  const selectedSet = new Set(value);
  const selectedCount = value.length;
  const isSearching = search.trim().length > 0;

  const toggleDestination = (id) => {
    if (selectedSet.has(id)) {
      onChange(value.filter(v => v !== id));
    } else {
      onChange([...value, id]);
    }
  };

  const findOption = (name) => {
    const lower = name.toLowerCase();
    return (options || []).find(o => (o.data?.name || '').toLowerCase() === lower)
        || (options || []).find(o => (o.data?.name || '').toLowerCase().startsWith(lower));
  };

  // Curated suggested list in fixed order
  const suggestedOptions = useMemo(() => {
    const result = [];
    for (const name of SUGGESTED_DESTINATIONS) {
      const opt = findOption(name);
      if (opt) result.push(opt);
    }
    return result;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options]);

  // Search results across ALL options
  const searchResults = useMemo(() => {
    if (!isSearching) return [];
    const s = search.toLowerCase();
    return (options || []).filter(o => (o.data?.name || '').toLowerCase().includes(s));
  }, [options, search, isSearching]);

  const displayList = isSearching ? searchResults : suggestedOptions;

  const renderItem = (opt) => {
    const isSelected = selectedSet.has(opt.value);
    return (
      <button
        key={opt.value}
        type="button"
        className={`sf-dest-list__item ${isSelected ? 'sf-dest-list__item--selected' : ''}`}
        onClick={() => toggleDestination(opt.value)}
      >
        <span className="sf-dest-list__item-name">{opt.data?.name || ''}</span>
        <span className={`sf-dest-list__item-check ${isSelected ? 'sf-dest-list__item-check--visible' : ''}`}>
          <FiCheck />
        </span>
      </button>
    );
  };

  return (
    <div className={`sf-dest-list ${validationError ? 'sf-field-error' : ''}`}>

      {/* Counter + Confirm row */}
      {selectedCount > 0 && (
        <div className="sf-dest-list__counter-row">
          <span className="sf-dest-list__counter">
            <FiCheck style={{ fontSize: '12px' }} />
            {selectedCount} {selectedCount === 1 ? 'seleccionado' : 'seleccionados'}
          </span>
          {onConfirm && (
            <button type="button" className="sf-dest-list__confirm-btn" onClick={onConfirm}>
              Continuar →
            </button>
          )}
        </div>
      )}

      {/* Search input */}
      <div className="sf-origin-selector__search-wrap">
        <FiSearch className="sf-origin-selector__search-icon" />
        <input
          type="text"
          className="sf-origin-selector__search-input"
          placeholder="Buscar destino..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          autoComplete="off"
          autoCorrect="off"
          spellCheck="false"
        />
        {search && (
          <button type="button" className="sf-origin-selector__search-clear" onClick={() => setSearch('')}>
            ×
          </button>
        )}
      </div>

      {/* Hint */}
      <p className="sf-dest-list__hint">Toca para seleccionar — puedes elegir varios destinos</p>

      {/* Section label */}
      <span className="sf-origin-selector__frecuentes-label">
        {isSearching ? 'RESULTADOS' : 'SUGERIDOS'}
      </span>

      {/* List */}
      <div className="sf-dest-list__items">
        {displayList.length > 0
          ? displayList.map(renderItem)
          : <p className="sf-origin-selector__no-results">No encontramos ese destino</p>
        }
      </div>

    </div>
  );
};

export default MobileDestinationHybrid;
